import { HTTPInstance } from "@http/http-instance";
import { DishSize } from "./SizesAPI.model";

export const getDishSizes = async (
  restaurantId: string,
): Promise<DishSize[]> => {
  const { data } = await HTTPInstance.get<DishSize[]>(
    `/public/restaurants/${restaurantId}/dish-sizes`,
  );
  return data;
};
